import React, {Component} from 'react'
import Loader from 'react-loader-spinner'
import {Link} from 'react-router-dom'
import CourseItem from '../CourseItem'
import './index.css'

const coursesApiUrl = 'https://apis.ccbp.in/te/courses'

class Home extends Component {
  state = {
    coursesList: [],
    isLoading: true,
    isError: false,
  }

  componentDidMount() {
    this.getCourses()
  }

  getCourses = async () => {
    this.setState({isLoading: true, isError: false})
    try {
      const response = await fetch(coursesApiUrl)
      if (response.ok) {
        const data = await response.json()
        const {courses} = data
        const formatted = courses.map(each => ({
          id: each.id,
          name: each.name,
          logoUrl: each.logo_url,
        }))
        this.setState({
          coursesList: formatted,
          isLoading: false,
          isError: false,
        })
      } else {
        this.setState({isLoading: false, isError: true})
      }
    } catch (e) {
      this.setState({isLoading: false, isError: true})
    }
  }

  render() {
    const {coursesList, isLoading, isError} = this.state

    let content = null

    if (isLoading) {
      content = (
        <div data-testid="loader" className="loader-container">
          <Loader type="TailSpin" color="#4656a1" height={50} width={50} />
        </div>
      )
    } else if (isError) {
      content = (
        <main className="failure-main">
          <img
            src="https://assets.ccbp.in/frontend/react-js/tech-era/failure-img.png"
            className="failure-image"
            alt="failure view"
          />
          <h1>Oops! Something Went Wrong</h1>
          <p>We cannot seem to find the page you are looking for</p>
          <button
            type="button"
            className="retry-button"
            onClick={this.getCourses}
          >
            Retry
          </button>
        </main>
      )
    } else {
      content = (
        <main className="content">
          <ul className="tech-list-container">
            {coursesList.map(each => (
              <CourseItem key={each.id} course={each} />
            ))}
          </ul>
        </main>
      )
    }

    return (
      <div className="tech-app-container">
        <header className="header">
          <Link to="/">
            <img
              src="https://assets.ccbp.in/frontend/react-js/tech-era/website-logo-img.png"
              className="logo"
              alt="website logo"
            />
          </Link>
        </header>
        <h1>Courses</h1>
        {content}
      </div>
    )
  }
}

export default Home
